import triyoAPI from './triyo';
import { config } from '../../util/axios-config';

//Search Api
export const Search = async (input) => {
    return await triyoAPI.get(`/search/search?searchtext=` + input, config());
}
